import Splide from '@splidejs/splide';
import { initSliderControls } from '../utils/slider-controls';

const initTestimonialsSlider = (section) => {
  if (section.dataset.testimonialsSliderReady === 'true') {
    return;
  }

  const sliderElement = section.querySelector('.testimonials-section__slider');
  const slides = Array.from(
    sliderElement?.querySelectorAll('.splide__slide') || []
  );
  const slideCount = slides.length;

  if (!sliderElement || !slideCount) {
    return;
  }

  const canLoop = slideCount > 1;
  const slider = new Splide(sliderElement, {
    arrows: false,
    drag: canLoop,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    keyboard: 'focused',
    pagination: false,
    perMove: 1,
    perPage: 1,
    type: canLoop ? 'loop' : 'slide',
  });

  initSliderControls({
    section,
    slider,
    slides,
    progressBar: section.querySelector('[data-testimonials-progress]'),
    progressThumb: section.querySelector('[data-testimonials-thumb]'),
    interval: 6000,
    speed: 700,
    getSlideLabel: (slide) =>
      slide?.querySelector('.testimonials-section__title')?.textContent.trim(),
  });

  slider.mount();

  section.dataset.testimonialsSliderReady = 'true';
};

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-testimonials-slider]')
    .forEach(initTestimonialsSlider);
});
